import {
    DESTROY_ACCOUNT, DESTROY_ANY_MAIL_ACCOUNT, GET_ACCOUNT_PII_STATUS,
    GET_ANY_MAIL_ACCOUNT_PII_STATUS, DELETE_SHARE
} from "../../redux/types";
import {GET_DESTROY_STATUS} from "../../redux/types";
import {GET_ACCOUNT_PII, GET_ANY_MAIL_ACCOUNT_PII} from "../../redux/types";

export const DESTROY_ACCOUNT_START = "DESTROY_ACCOUNT_START";

export const destroyAccount = (email, brand, onSuccess, onFailure) => dispatch => {
    dispatch({type: DESTROY_ACCOUNT_START});

    dispatch({
        type: brand === 'AM' ? DESTROY_ANY_MAIL_ACCOUNT : DESTROY_ACCOUNT,
        onSuccess,
        onFailure,
        payload: email
    });
};

export const GET_DESTROY_STATUS_START = "GET_DESTROY_STATUS_START";

export const getDestroyStatus = email => dispatch => {
    dispatch({type: GET_DESTROY_STATUS_START});

    dispatch({
        type: GET_DESTROY_STATUS,
        payload: email
    });
};

export const GET_ACCOUNT_PII_START = "GET_ACCOUNT_PII_START";

export const getAccountPII = (email, brand) => dispatch => {
    dispatch({type: GET_ACCOUNT_PII_START});

    const type = brand === 'AM' ? GET_ANY_MAIL_ACCOUNT_PII : GET_ACCOUNT_PII;

    dispatch({
        type,
        payload: email
    });
};

export const GET_ACCOUNT_PII_STATUS_START = "GET_ACCOUNT_PII_STATUS_START";

export const getAccountPIIStatus = (email, brand) => dispatch => {
    dispatch({type: GET_ACCOUNT_PII_STATUS_START});

    const type = brand === 'AM' ? GET_ANY_MAIL_ACCOUNT_PII_STATUS : GET_ACCOUNT_PII_STATUS;
    dispatch({
        type,
        payload: email
    });
};


export const DELETE_SHARE_START = "DELETE_SHARE_START";

export const deleteShare = (url) => dispatch => {
    dispatch({type: DELETE_SHARE_START});

    const type = DELETE_SHARE;

    dispatch({
        type,
        payload: url
    });
};


// WEBPACK FOOTER //
// ./src/containers/delete-account/DeleteAccountActions.js